export default "__VITE_ASSET__LyVE4dJy__"